<script>
  import { _ } from 'svelte-i18n'
</script>
<p>
  <!-- Better: Wordmark is built to work on desktop computers where font selection takes a lot of time in design programs. It saves a lot o f time by streamlining the font selection process. You should try it on your computer. Unfortunately it cannot detect the fonts added to your tablet or iphone making it not that useful in these devices. -->
  {$_('inserts.yourFonts.didYou')}<br><br>
  Visit Wordmark on your desktop computer to see them here.<br><br>
  Unfortunately Wordmark cannot show the fonts you have added to your phone or tablet.
</p>

<style>
  p {
    margin: 1rem 0 0 0.2rem;
    font-family: var(--PensumSans-Bold);
    font-size: 2.5rem;
    line-height: 3rem;
    color: var(--c-accent);
  }

  @media only screen and (min-width: 820px) {
    p {
      max-width: 82rem;
    }
  }
</style>